var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-matrix"},[_c('matrix-row',_vm._l((_vm.columnTitles),function(title,key){return _c('span',{key:key},[_vm._v(_vm._s(title))])}),0),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }